import { LineageNode } from './index';

export type NodeKind =
    'table' | 'view' | 'semantic-model' | 'bi-report' | 'workbook' | 'data-source' | 'plugin-source' | 'other';

export const SEMANTIC_MODEL_GROUP = 'external-semantic-model';
export const ROLLUP_GROUP = 'external-rollup';

const KIND_BY_GROUP: Record<string, NodeKind> = {
    'external-metadata': 'table',
    'external-metadata-view': 'view',
    [SEMANTIC_MODEL_GROUP]: 'semantic-model',
    'external-dataset': 'bi-report',
    [ROLLUP_GROUP]: 'workbook',
    'external-source': 'data-source',
    plugin: 'plugin-source',
};

export const getNodeKind = (node: Pick<LineageNode, 'group' | 'params'>): NodeKind =>
    KIND_BY_GROUP[node.group ?? ''] ?? 'other';
